import routes from './routes'

export default Object.assign.apply(null, Object.values(routes))
